import React from 'react';

const AdminDashboard = () => {
    return (
        <div className='grid grid-cols-2 gap-5 my-10'>
            <div className='w-full h-20 bg-gray-50 border border-gray-400 rounded-xl shadow-sm'></div>
            <div className='w-full h-20 bg-gray-50 border border-gray-400 rounded-xl shadow-sm'></div>
        </div>
    );
};

export default AdminDashboard;